import "./Productsheading.css"
import IMG1 from "./hdimg.png"

function Productsheading() {
    return(
        <h1 className="Productsheading-container"><img id="pheadimg" src={IMG1} alt="pddesign" />Our Feature Products</h1>
    )
}

export default Productsheading